/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeliItemSyncAssignmentHints } from './MeliItemSyncAssignmentHints';
import type { MeliItemSyncImportOptions } from './MeliItemSyncImportOptions';
import type { MeliItemSyncMetadata } from './MeliItemSyncMetadata';
import type { MeliItemSyncProperty } from './MeliItemSyncProperty';
import type { MeliItemSyncPublication } from './MeliItemSyncPublication';
import type { MeliItemSyncSourceMediaItem } from './MeliItemSyncSourceMediaItem';
/**
 * Authoritative MercadoLibre item snapshot body.
 */
export type MeliItemSyncBody = {
    /**
     * Provider identifier for this sync payload.
     */
    provider: MeliItemSyncBody.provider;
    /**
     * MercadoLibre seller id associated with the item snapshot.
     */
    providerSubject: string;
    /**
     * Canonical property payload to upsert.
     */
    property: MeliItemSyncProperty;
    /**
     * Canonical MeLi publication snapshot.
     */
    publication: MeliItemSyncPublication;
    /**
     * Shared import/sync options applied to this snapshot.
     */
    importOptions?: MeliItemSyncImportOptions | null;
    /**
     * Optional seller-contact hints for assignment resolution.
     */
    assignmentHints?: MeliItemSyncAssignmentHints | null;
    /**
     * Remote media references attached to the source snapshot.
     */
    sourceMedia?: Array<MeliItemSyncSourceMediaItem> | null;
    /**
     * Metadata about the source event that produced this snapshot.
     */
    syncMetadata?: MeliItemSyncMetadata | null;
};
export namespace MeliItemSyncBody {
    /**
     * Provider identifier for this sync payload.
     */
    export enum provider {
        MELI = 'meli',
    }
}

